import React from 'react';
import { Box, Divider, Stack } from '@mui/material';
import { InfoOutline } from '@mui/icons-material';
import { InfoCard } from './InfoCard';
import { InfoRow } from './InfoRow';
import { OfferListItem } from '../../../types';
import { useOfferConfig } from '../../../contexts';
import { getLabelsFromOptionIds } from '../../../utils/labelHelpers';
import StatusChip from '@shared/components/StatusChip/StatusChip';
import { SyncOnChip } from '../../../components/SyncOnChip';

interface OfferBasicInfoProps {
  offer: Partial<OfferListItem>;
}

export const OfferBasicInfo: React.FC<OfferBasicInfoProps> = ({ offer }) => {
  const { scopeOptions, countryOptions } = useOfferConfig();

  return (
    <InfoCard title="Basic Information" icon={<InfoOutline sx={{ fontSize: 15 }} />}>
      <Stack spacing={1}>
        <InfoRow label="Offer ID" value={offer.offer_id} />
        <Divider />
        <InfoRow label="Offer Name" value={offer.offer_name} />
        <Divider />
        <InfoRow label="Price / Currency" value={`${offer.price} ${offer.currency}`} />
        <Divider />
        <InfoRow label="Category" value={offer.offer_category} />
        <Divider />
        <InfoRow
          label="Country"
          value={
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, ml: '5px' }}>
              {offer.country && offer.country !== ''
                ? getLabelsFromOptionIds(offer.country, countryOptions).join(', ')
                : 'All countries'}
            </Box>
          }
        />
        {offer.duration !== null && offer.duration !== undefined && (
          <>
            <Divider />
            <InfoRow label="Duration" value={`${offer.duration} seconds`} />
          </>
        )}
        <Divider />
        <InfoRow
          label="Platform"
          value={
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {getLabelsFromOptionIds(offer.scope, scopeOptions).map((label, idx) => (
                <StatusChip key={idx} label={label} status="primary" variant="outlined" />
              ))}
            </Box>
          }
        />
        <Divider />
        <InfoRow label="Environment" value={<SyncOnChip value={offer.sync_on} showIcon />} />
      </Stack>
    </InfoCard>
  );
};
